import { FieldSet } from "../../../../../../components/utils/useFieldSet";
import { JobAppPersonalInformationRequest } from "../../../../../api-docs";
import { PersonalInfoFragment } from "../../../../components/self-apply-application-form-fragments/personal-info";
import { PublicJobSectionGraph } from "../../../../../graphql.types";
import { SelfApplySectionContainer } from "../../../../components/self-apply-section-container";

export const SelfApplyPersonalInfoAppSection = (props: {
  fieldSet: FieldSet<JobAppPersonalInformationRequest>;
  section: PublicJobSectionGraph;
  enableEmail?: boolean;
  isAgencyApply?: boolean;
}) => {
  const { section, fieldSet } = props;
  return (
    <SelfApplySectionContainer.Container
      key={section?.id}
      description={section?.description ?? ""}
      title={
        props.isAgencyApply ? "Candidate Information" : section?.name || ""
      }
      isRequired={section?.isRequired}
    >
      <SelfApplySectionContainer.Content>
        <div className="pt-8">
          <PersonalInfoFragment
            {...fieldSet}
            firstNameRequired
            lastNameRequired
            enableEmail={props.enableEmail}
          />
        </div>
      </SelfApplySectionContainer.Content>
    </SelfApplySectionContainer.Container>
  );
};
